import React, { useState } from "react";
import { useFetchAllStatsQuery } from "../../store/api/apiSlice";
const StatsManagement = () => {
  const { data: stats, isLoading, error } = useFetchAllStatsQuery();

  return (
    <div className="container">
         
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "22px",
        }}
      >
        <h3 className="mb-4">Stats</h3>
       
      </div>
      <div className="stats-container">
        <h2 className="stats-title"></h2>
        <div className="stats-item">
          <strong>Total Users Today:</strong> {stats?.totalUsersToday}
        </div>
        <div className="stats-item">
          <strong>Total Active Forums:</strong> {stats?.totalActiveForums}
        </div>
        <div className="stats-item">
          <strong>Total Forum Messages Today:</strong>{" "}
          {stats?.totalForumMessagesToday}
        </div>
        <div className="stats-item">
          <strong>Total News Today:</strong> {stats?.totalNewsToday}
        </div>
        <div className="stats-item">
          <strong>Total Users Added in Play Game:</strong>{" "}
          {stats?.totalUsersAddedInPlayGame}
        </div>
        <div className="stats-item">
          <strong>Total Teams:</strong> {stats?.totalTeams}
        </div>
        <div className="stats-item">
          <strong>Total Votes Today:</strong> {stats?.totalVotesToday}
        </div>

        <h2 className="stats-title">API Key Information</h2>
        <pre>{JSON.stringify(stats?.serpapi, null, 2)}</pre>
      </div>
    </div>
  );
};

export default StatsManagement;
